import { Card, Table, Tag } from 'antd'
import { useNavigate } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import axiosInstance from '@/lib/axios'

interface PurchaseRequestRow {
  id: number
  work_order_id?: number
  codice?: string
  purchase_request_status_nome?: string
  fornitore?: string
  data_richiesta?: string
  cliente_nome?: string
  targa?: string
  marca?: string
  modello?: string
}

const STATI_ATTIVI = new Set(['Bozza', 'In attesa approvazione', 'Approvata', 'Ordinata'])

const STATO_COLOR: Record<string, string> = {
  'Bozza':                  'default',
  'In attesa approvazione': 'orange',
  'Approvata':              'blue',
  'Ordinata':               'green',
}

const columns = [
  {
    title: 'Codice',
    dataIndex: 'codice',
    key: 'codice',
    width: 120,
    render: (v: string) => v ?? '—',
  },
  {
    title: 'Cliente',
    dataIndex: 'cliente_nome',
    key: 'cliente_nome',
    render: (v: string) => v || '—',
  },
  {
    title: 'Veicolo',
    key: 'veicolo',
    render: (_: unknown, row: PurchaseRequestRow) => {
      const parts = [row.targa, row.marca, row.modello].filter(Boolean)
      return parts.length ? parts.join(' · ') : '—'
    },
  },
  {
    title: 'Fornitore',
    dataIndex: 'fornitore',
    key: 'fornitore',
    render: (v: string) => v ?? '—',
  },
  {
    title: 'Stato',
    dataIndex: 'purchase_request_status_nome',
    key: 'stato',
    width: 180,
    render: (v: string) => v ? <Tag color={STATO_COLOR[v] ?? 'default'}>{v}</Tag> : '—',
  },
  {
    title: 'Data',
    dataIndex: 'data_richiesta',
    key: 'data_richiesta',
    width: 100,
    render: (v: string) => v ? new Date(v).toLocaleDateString('it-IT') : '—',
  },
]

export function TableOrdiniRecentiWidget() {
  const navigate = useNavigate()
  const { data, isLoading } = useQuery<PurchaseRequestRow[]>({
    queryKey: ['dashboard', 'ordini-recenti-attivi'],
    queryFn: async () => {
      const res = await axiosInstance.get('/purchase-requests/?limit=30&skip=0')
      const rows: PurchaseRequestRow[] = Array.isArray(res.data) ? res.data : (res.data?.items ?? [])
      return rows
        .filter(r => STATI_ATTIVI.has(r.purchase_request_status_nome ?? ''))
        .slice(0, 10)
    },
    staleTime: 30000,
  })

  return (
    <Card size="small" title="RDO attive">
      <Table
        columns={columns}
        dataSource={data ?? []}
        rowKey="id"
        size="small"
        loading={isLoading}
        pagination={false}
        scroll={{ x: 500 }}
        locale={{ emptyText: 'Nessuna RDO attiva' }}
        onRow={(r) => ({ onClick: () => navigate('/rda', { state: { expandWorkOrderId: r.work_order_id } }), style: { cursor: 'pointer' } })}
      />
    </Card>
  )
}
